// FH perf: inline scripts that call $(fn) / $(document).ready(fn) before jQuery has loaded are
// queued by a small stub in layout/theme.liquid (jQuery now loads with defer). Replay them at
// DOMContentLoaded, the same moment they ran when jQuery loaded synchronously, so deferred
// libraries they rely on (e.g. the Findation widget) are ready.
(function () {
  var queue = window.__fhJqReady;
  window.__fhJqReady = null;
  if (!queue || !window.jQuery) return;
  function run() {
    queue.forEach(function (fn) {
      try { fn.call(document, jQuery); } catch (e) { setTimeout(function () { throw e; }); }
    });
  }
  if (window.__fhDomReady) run(); else document.addEventListener('DOMContentLoaded', run);
})();

// // Transitions
// barba.use(barbaPrefetch);
// barba.use(barbaCss);

// barba.init({
// preventRunning: true,
// timeout: 5000,
// // sync: true,
// cacheIgnore: ['/cart/', '/account/'],
// transitions: [
//   {
//     name: 'with-color',
//     leave() {},
//     enter() {},
//   },
//   {
//     name: 'with-image',
//     from: {
//       namespace: [
//         'product'
//       ]
//     },
//     leave() {},
//     enter() {},
//   },
//   {
//     name: 'self',
//     enter() {}
//     }
//   ],
//   views: [
//     {
//       namespace: 'product',
//       beforeEnter(data) {
//         $('script.product-data').remove().appendTo('html');
//         $('script.ajax-cart').remove().appendTo('html');
//       }
//     }
// ]
// });

// // body classes
// barba.hooks.afterLeave((data) => {
//   var nextHtml = data.next.html;
//   var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml)
//   var bodyClasses = $(response).filter('notbody').attr('class')
//   $("body").attr("class", bodyClasses);

// });

// barba.hooks.beforeLeave((data) => {
//   $('.submenu-mobile').removeClass('menu-open');
//   $('.open-menu').show();
//   $('.close-menu').hide();
// });

// // scroll behaviour
// barba.hooks.afterEnter((data) => {

//   if ('scrollRestoration' in history) {
//     history.scrollRestoration = 'manual';
//   }
//   window.scrollTo(0, 0);

// });

// product data
// barba.hooks.after((data) => {
//   var inlineScript = $(container).find('script.productData')
//   inlineScript.each(function(i, elm) {
//     eval(elm.innerHTML);
//   })
// });

// // load on transition
// barba.hooks.beforeEnter((data) => {

//   // const updateItems = $(data.next.html).find('.menu-item');
//   // const updateLang = $(data.next.html).find('.language-chooser li');
//   //
//   // $('.menu-item').each(function(index) {
//   //     const newClasses = $(updateItems[index]).get(0).classList.value;
//   //     $(this).attr('class', newClasses);
//   // });
//   //
//   // $('.language-chooser li').each(function(index) {
//   //     const newClasses = $(updateLang[index]).get(0).classList.value;
//   //     $(this).attr('class', newClasses);
//   // });

// reloadScripts();

// });

// load scripts
$(function() {
  reloadScripts();

  // menu height
  $(function() {
    var submenuHeight = $(".submenu").outerHeight(true);
    var header2Height = $('.header2').outerHeight(true);
    $(".header2").css("height", header2Height + submenuHeight);
  })

});

// scripts
function reloadScripts() {

  // home slider
  $('.home .shopify-section').contents().unwrap();


  // FH fix: '.slider' also matches Dawn's product image gallery (ul.product__media-list.slider),
  // which is not a Swiper. Setting Swiper up on it made autoplay throw
  // "Cannot read properties of undefined (reading 'clientLeft')" every 5s on product pages, and
  // clicking a product image called slideNext on it. Only real Swiper markup (an element with a
  // direct .swiper-wrapper child) is set up now.
  const fhSwiperEls = function (selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector)).filter(function (el) {
      return el.querySelector(':scope > .swiper-wrapper');
    });
  };
  const fhSliderEls = fhSwiperEls('.slider');
  const fhChildSliderEls = fhSwiperEls('.child-slider');

  const swiper = fhSliderEls.length && new Swiper(fhSliderEls[0], {

    direction: 'horizontal',
    loop: true,
    speed: 1000,
    effect: 'fade',
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },

  });

  $(fhSliderEls).on("click", function() {
    swiper?.slideNext();
  })

  const swiperChild = fhChildSliderEls.length && new Swiper(fhChildSliderEls[0], {

    direction: 'vertical',
    loop: false,
    speed: 1000,
    effect: 'slide',
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true
    },
    mousewheel: {
      forceToAxis: true
    }

  });

  // shop menu
  $('[data-menu]').on("mouseenter", function() {
    var thisData = $(this).attr("data-menu")
    $('.submenu').fadeIn(500);
    $('.submenu-single').not($('.submenu-single#' + thisData)).fadeOut(500);
    $('.submenu-single#' + thisData).fadeIn(500);


    return false
    // $('.header2').addClass("submenu-visible");
  })

  $('.submenu').on("mouseleave", function() {
    $('.submenu').fadeOut(500);
    // $('.header2').removeClass("submenu-visible");
  })



  $('.submenu .data-hover ').on("mouseleave", function() {
    $('.submenu .data-hover').css('color', 'inherit');
  })

  // menu products
  $('.submenu .data-hover').on("mouseenter", function() {

    var pantoneColor = $(this).attr('data-hover');
    $(this).css('color', pantoneColor);

    var collectionName = $(this).attr('id');
    $('.menu-products > div').not('#menu-' + collectionName).removeClass("products-open");
    $('.menu-products > div#menu-' + collectionName).addClass("products-open");
  })

  // cart qty
  $(function() {
      // This button will increment the value
      $('.qtyplus').click(function(e){
          // Stop acting like a button
          e.preventDefault();
          // Get the field name
          fieldName = $(this).attr('field');
          // Get its current value
          var currentVal = parseInt($('input[id='+fieldName+']').val());
          // If is not undefined
          if (!isNaN(currentVal)) {
              // Increment
              $('input[id='+fieldName+']').val(currentVal + 1);
          } else {
              // Otherwise put a 0 there
              $('input[id='+fieldName+']').val(0);
          }
          $( "#update" ).trigger( "click" );

      });
      // This button will decrement the value till 0
      $(".qtyminus").click(function(e) {
          // Stop acting like a button
          e.preventDefault();
          // Get the field name
          fieldName = $(this).attr('field');
          // Get its current value
          var currentVal = parseInt($('input[id='+fieldName+']').val());
          // If it isn't undefined or its greater than 0
          if (!isNaN(currentVal) && currentVal > 0) {
              // Decrement one
              $('input[id='+fieldName+']').val(currentVal - 1);
          } else {
              // Otherwise put a 0 there
              $('input[id='+fieldName+']').val(0);
          }
          $( "#update" ).trigger( "click" );

      });
  });

  $(function() {
    $('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });
  });

  // // transition color
  // $('.plp-product').on("click", function() {
  //   var thisColor = $(this).attr("data-transition");
  //   console.log(thisColor)
  //   $('.transition').css("background", thisColor);
  // })

  // slow beauty blocks
  $(function() {

    $(':not(.image-block) + .image-block, * > .image-block:first-of-type').
       each(function() {
         $(this).
             nextUntil(':not(.image-block)').
             addBack().
             wrapAll('<div class="image-wrapper w-100 flex flex-column flex-row-l justify-between" />');
    });

  });

  // search
  $(function() {
    $('.search-btn').on("click", function() {
      $('.search-btn input').addClass("expanded").select();
    })
  })

  // random editorial
      //   $.fn.shuffleChildren = function() {
      //   $.each(this.get(), function(index, el) {
      //     var $el = $(el);
      //     var $find = $el.children();
      //
      //     $find.sort(function() {
      //       return 0.5 - Math.random();
      //     });
      //
      //     $el.empty();
      //     $find.appendTo($el);
      //   });
      // };
      //
      // $(function() {
      //    $(".plp-collection").shuffleChildren();
      // })

      $(function() {

      // menu slider
      $('.menu-slider').each(function() {
        const slidesToShow = $(this).data('item-to-show') || 1; // fallback = 1
      
        new Swiper(this, {
          direction: 'horizontal',
          loop: false,
          // FH perf: menu thumbnails load when the menu opens (see sections/header-new.liquid),
          // not when Swiper starts.
          preloadImages: false,
          slidesPerView: slidesToShow,
          navigation: {
            nextEl: $(this).find('.swiper-button-next')[0],
            prevEl: $(this).find('.swiper-button-prev')[0],
          },
        });
      });

    });


  // product
  function sliderMobile() {
   if ($(window).width() <= 960) {

     $('.header2').addClass("is-mobile");

      // FH fix: this runs on every resize event (phones fire them constantly while scrolling).
      // It used to create a new Swiper, and bind another click handler, every time. Now it only
      // sets up a .product-slider that exists and has not been set up yet.
      const fhProductSliderEl = document.querySelector('.product-slider');
      if (!fhProductSliderEl || fhProductSliderEl.swiper) return;

      const productSlider = new Swiper(fhProductSliderEl, {

        direction: 'horizontal',
        loop: true,
        speed: 1000,
        effect: 'fade',
        autoHeight: true,
        allowTouchMove: true,
        fadeEffect: {
          crossFade: true
        },

        navigation: {
          nextEl: '.product-slider',
        },

        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },


      });
     
        productSlider.on('slideChange', function () {
          $('.swiper-pagination-message').hide();
          $('.swiper-pagination').show()
        });

        var currentVariant = $('.product-images').attr("data-scroll");
        var selectedIndex = $('.swiper-slide#' + currentVariant).attr("data-number")
      //  productSlider.slideTo(selectedIndex);


        $('.color-circle').on("click", function() {
          var colorVariant = $(this).attr("data-variant");
          var slideIndex = $('.swiper-slide#' + colorVariant).attr("data-number");
       //  productSlider.slideTo(slideIndex);

        })

      }
  };

  $(function() {
    sliderMobile();
    $(window).on('resize', function(){
      sliderMobile();
    });
  })

    $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).scroll(function() {

  var lastElem = null;

  $('.product-image').each(function(i) {
    if ($(this).isInViewport()) {
      lastElem = $(this)
    }
  });

  if (lastElem != null) {
    var number = lastElem.attr("data-number");
    $('.current-product-image').text(number)
  }
}).scroll();

  $(".acc-content").hide();
  $(".acc-toggler").on("click",function(e){
  	var accContent = $(this).next(".acc-content");

  	$(".acc-content").not(accContent).slideUp();
  	accContent.slideToggle();
  });

  // product image scroll
  // $(function() {
  //
  //         var currentVariant = $('.product-images').attr("data-scroll");
  //
  //         $('html, body').animate({
  //             scrollTop: $('#' + currentVariant).offset().top
  //         }, 1000);
  //
  //         $('.color-circle').on("click", function() {
  //
  //           var colorVariant = $(this).attr("data-variant");
  //
  //           $('html, body').animate({
  //               scrollTop: $('#' + colorVariant).offset().top
  //           }, 1000);
  //         })
  //
  // });

  // menu trigger
  $(function() {
    $('.open-menu').on("click", function() {
      $('.submenu-mobile').addClass('menu-open');

      if( $('.submenu-mobile').hasClass('menu-open') ) {
        $('.close-menu').show();
        $('.open-menu').hide();
      }
      else {
        $('.open-menu').show();
        $('.close-menu').hide();
      }
    })

    $('.close-menu').on("click", function() {
      $('.submenu-mobile').removeClass('menu-open');
      $('.open-menu').show();
      $('.close-menu').hide();

    })

  })

}
